/* eslint-disable no-undef */
export const copyToClipboard = async (str = ''): Promise<void> => {
  if (navigator && navigator.clipboard) {
    await navigator.clipboard.writeText(str);
  }
};
